export default __webpack_public_path__ + "static/media/logo-bolivar.499f83a7.webp";